import api from '../index'

export default {
  // 所有角色
  get_all_role_list: () => api.get('/system/role/role/get_all_role_list'),
  // 角色列表
  get_role_list: (page: number, pagesize: number, role_name?: string) => api.get('/system/role/role/get_role_list', {
    params: {
      page,
      pagesize,
      role_name,
    },
  }),

  // 保存角色
  save_role: (data: {
    role_id: number
    role_name: string
    role_describe: string
    code_list: string[]
  }) => api.post('/system/role/role/save_role', data),
  // 获取角色详情
  get_role_info: (role_id: number) => api.get('/system/role/role/get_role_info', {
    params: {
      role_id,
    },
  }),
  // 删除角色
  del_role: (role_id: number) => api.post('/system/role/role/del_role', {
    role_id,
  }),
  // 获取角色权限列表
  get_role_authority_list: (role_id: string) => api.get('/system/role/role/get_role_authority_list', {
    params: {
      role_id,
    },
  }),
  // 角色用户列表
  get_role_user_list: (role_id: number, page: number, pagesize: number) => api.get('/system/role/role/get_role_user_list', {
    params: {
      role_id,
      page,
      pagesize,
    },
  }),
  // 删除角色用户
  del_role_user: (role_id: number, user_id: number) => api.post('/system/role/role/del_role_user', {
    role_id,
    user_id,
  }),
  // 用户列表
  get_user_list: (page: number, pagesize: number, keyword?: string, is_disable?: number | string, mobile?: string, is_admin?: number | string, school_id?: number | string) => api.get('/system/user/user/get_user_list', {
    params: {
      page,
      pagesize,
      keyword,
      is_disable,
      mobile,
      is_admin,
      school_id,
    },
  }),

  // 保存用户
  save_user: (data: {
    user_id: number
    user_name: string
    password: string
    mobile: string
    user_code: string
    is_admin: string
    remark: string
  }) => api.post('/system/user/user/save_user', data),

  // 禁用用户
  disable_user: (user_id: number, reason: string) => api.post('/system/user/user/disable_user', {
    user_id,
    reason,
  }),

  // 删除用户
  del_user: (user_id: number) => api.post('/system/user/user/del_user', {
    user_id,
  }),

  // 解锁用户
  unlock_user: (user_id: number, reason: string) => api.post('/system/user/user/unlock_user', {
    user_id,
    reason,
  }),

  // 重置用户密码
  reset_user_password: (user_id: number, password: string) => api.post('/system/user/user/reset_user_password', {
    user_id,
    password,
  }),

  // 获取用户权限信息
  get_user_authority_info: (user_id: number) => api.get('/system/user/user/get_user_authority_info', {
    params: {
      user_id,
    },
  }),

  // 保存用户权限
  save_user_authority: (data: {
    user_id: number
    role_id_list: number[]
    school_id_list: number[]
  }) => api.post('/system/user/user/save_user_authority', data),

  // 学校管理员用户列表
  get_admin_user_list: (page: number, pagesize: number, keyword?: string, school_id?: number) => api.get('/tenant/school/user/get_admin_user_list', {
    params: {
      page,
      pagesize,
      keyword,
      school_id,
    },
  }),

  // 获取用户安全信息
  userSafeInfo: () => api.get('user/user_safe_info', {
    baseURL: '/mock/',
  }),

  // 校验密码状态
  checkPwd: () => api.get('user/check_pwd', {
    baseURL: '/mock/',
  }),

  // 获取权限
  permission: () => api.get('user/permission', {
    baseURL: '/mock/',
  }),

  // 获取当前用户信息
  get_my_user_info: () => api.get('/home/user_center/get_user_info'),

  // 用户详情
  get_user_info: (user_id: number) => api.get('/system/user/user/get_user_info', {
    params: {
      user_id,
    },
  }),
  // 更新用户信息
  update_user_info: (data: {
    user_name: string
    mobile: string
    email?: string
    signature?: string
    avatar?: string
  }) => api.post('/home/user_center/update_user_info', data),

  // 修改密码
  change_password: (data: {
    old_password: string
    new_password: string
    confirm_password: string
  }) => api.post('/home/user_center/change_password', data),

  // 获取登录日志
  get_user_log_list: (page: number, pagesize: number) => api.get('/home/user_center/get_login_log_list', {
    params: {
      page,
      pagesize,
    },
  }),

  // 上传头像
  upload_avatar: (formData: FormData) => api.post('/home/user_center/upload_avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),

  // 获取权限码列表
  get_authority_code_list: () => api.get('/home/user_center/get_authority_code_list'),
}
